<template lang="html">
  <div class="row comms-history">
    <p
      v-if="loading"
      class="loading-text"
    >
      Generating data...
    </p>
    <div
      v-else
      class="col-lg-12 lbv-event-history"
    >
      <b-card header="Communications">
        <b-table
          :items="commsHistoryItems"
          :fields="testCommsHistoryFields"
          :sort-compare="commsEventCustomSort"
        >
          <template
            slot="id"
            slot-scope="row"
          >
            <!-- We use @click.stop here to prevent a 'row-clicked' event from also happening -->
            <b-button
              size="sm"
              variant="primary"
              @click.stop="showModal(row.item, row.index, $event.target)"
            >
              View
            </b-button>
          </template>
        </b-table>
        <div
          v-if="showPagination"
          class="pagination"
        >
          <b-button
            class="page prev"
            variant="primary"
            size="sm"
            :disabled="pageNumber === 1"
            @click.prevent="page"
          >
            Prev
          </b-button>
          <div class="current-page">
            Page: {{ pageNumber }}
          </div>
          <b-button
            class="page next"
            variant="primary"
            size="sm"
            :disabled="!hasNextPage"
            @click.prevent="page"
          >
            Next
          </b-button>
        </div>
      </b-card>
      <!-- Info modal -->
      <b-modal
        id="modalInfo"
        :title="modalInfo.title"
        ok-only
        @hide="resetModal"
      >
        <div
          slot="modal-header"
          class="card-header"
        >
          <span class="head-section">{{ modalInfo.commEvent }}</span>
          <span class="head-section">{{ modalInfo.commType }} </span>
          <span class="head-section">{{ modalInfo.date }} </span>
          <span class="head-section">{{ modalInfo.commSubject }}</span>
        </div>
        <div
          class="email-body"
          v-html="modalInfo.content"
        />
      </b-modal>
    </div>
  </div>
</template>

<script>
import { TabNavEvent } from '../../events/tabNavEvent'
import { APIEvent } from '../../events/apiEvent'
import { StatusBarEvent } from '../../events/statusBarEvent'
import { EventBus } from '../../event-bus'
import { B64ToUTF8 } from '../../utils'
import { MESSAGE_EVENTS } from '../../constants/userComms/commsEventNames'

export default {
  name: 'CommsHistoryView',
  props: ['lb_id'],
  data () {
    return {
      modalInfo: { title: '', content: '' },
      testCommsHistoryFields: [
        {
          key: 'emailCode',
          label: 'Comms Event',
          sortable: false,
          formatter: this.translateCommsEvent
        },
        {
          key: 'code',
          label: 'Comms Type',
          sortable: false
        },
        {
          key: 'messageStatus',
          label: 'Status',
          sortable: false
        },
        {
          key: 'messageUpdated',
          label: 'Date',
          sortable: false
        },
        {
          key: 'id',
          label: 'Actions'
        }
      ],
      commsHistoryItems: [],
      loading: true,
      pageNumber: 1,
      hasNextPage: false,
      startOffset: 0,
      perPage: 20
    }
  },
  computed: {
    showPagination: function () {
      return this.hasNextPage || this.pageNumber > 1
    }
  },
  mounted () {
    EventBus.$on(TabNavEvent.COMMS_HISTORY, () => { this.init() })
  },
  destroyed () {
    EventBus.$off(TabNavEvent.COMMS_HISTORY)
  },
  methods: {
    init: function () {
      this.fetchCommsHistory()
    },
    fetchCommsHistory: function () {
      if (this.lb_id) {
        let data = {}
        data.leakbotid = this.lb_id
        data.start_record = this.startOffset.toString()
        data.fetch_size = this.perPage.toString()
        this.$store.dispatch(APIEvent.FETCH_USER_COMMS, data)
          .then((response) => {
            this.loading = false
            this.commsHistoryItems = response.data.list.records
            this.commsHistoryItems = response.data.list.records?.map(item => {
              return {...item, 'messageStatus': item.isSent === '0' ? 'Queued' : item.isSent === '1' ? 'Sent' : 'Not sent'}
            })
            this.hasNextPage = response.data.LastPage === '0'
          })
          .catch(this.handleError)
      }
    },
    page (event) {
      var next = event.currentTarget.className.indexOf('next') > -1
      if (next) {
        this.startOffset += this.perPage
        this.pageNumber += 1
      } else {
        this.startOffset -= this.perPage
        this.pageNumber -= 1
      }
      this.fetchCommsHistory()
    },
    showModal: function (item, index, button) {
      let eventData = item
      this.$store.dispatch(APIEvent.FETCH_USER_EMAIL, item.id)
        .then((response) => {
          let data = response.data
          this.modalInfo = this.parseContent(data, eventData)
          this.$root.$emit('bv::show::modal', 'modalInfo')
        })
        .catch(this.handleError)
    },
    parseContent: function (data, item) {
      let modalInfo = {}
      modalInfo.content = this.decodeBody(data.body, data.tokens, data.tokenValues, data.subject)
      modalInfo.date = item.messageUpdated
      modalInfo.commType = item.code
      modalInfo.commSubject = B64ToUTF8(item.subject)
      modalInfo.commEvent = this.translateCommsEvent(item.emailCode)
      return modalInfo
    },
    decodeBody: function (encoded, tokens, tokenValues) {
      tokens = tokens.split('|')
      tokenValues = tokenValues.split('|')
      tokens.push('{{new_line}}')
      tokenValues.push('<br >')
      let decoded = B64ToUTF8(encoded)
      for (var i = 0; i < tokens.length; i++) {
        decoded = decoded.replace(tokens[i], tokenValues[i])
      }
      return decoded
    },
    resetModal: function () {
      this.modalInfo.title = ''
      this.modalInfo.content = ''
    },
    translateCommsEvent: function (value) {
      return MESSAGE_EVENTS[value]
    },
    commsEventCustomSort: function (a, b, key) {
      // applies custom sort only when key is email code
      if (key === 'emailCode') {
        let me = MESSAGE_EVENTS
        let aCode = a.emailCode
        let bCode = b.emailCode
        return me[aCode] < me[bCode] ? -1 : (me[aCode] > me[bCode] ? 1 : 0)
      } else {
        // uses default sort for all other fields
        return null
      }
    },
    handleError: function (error) {
      EventBus.$emit(StatusBarEvent.ERROR, error.message)
    }
  }
}
</script>

<style lang="css">
  .loading-text {
    margin: 1rem auto;
  }

  #modalInfo .modal-header {
    padding: 0px;
    text-align: left;
  }
  #modalInfo .card-header {
    width: 100%;
    padding: 0 10px;
  }
  #modalInfo .head-section {
    border-right: 1px solid rgba(50, 211, 197, 1);
    display: inline-block;
    padding: 1rem;
    vertical-align: middle;
    font-weight: bold;
  }
  #modalInfo .head-section:last-of-type {
    border: none;
  }
  #modalInfo .email-body h3{
    font-size: 1rem;
  }

  #modalInfo .modal-dialog {
    max-width: 80% !important;
  }

  .lbv-event-history .pagination {
    width: 100%;
  }

  .lbv-event-history .current-page {
    margin-top: 15px;
  }

</style>
